import React from "react";
import DashboardIcon from "@material-ui/icons/Dashboard";
import PeopleIcon from "@material-ui/icons/People";
import HelpIcon from "@material-ui/icons/Help";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import SettingsIcon from "@material-ui/icons/Settings";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import TransformIcon from "@material-ui/icons/Transform";
import TableChartIcon from "@material-ui/icons/TableChart";
import PersonIcon from "@material-ui/icons/Person";
import PaymentIcon from "@material-ui/icons/Payment";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
export const sidebarItems = [
  {
    id: 1,
    name: "Dashboard",
    icon: <DashboardIcon />,
    to: "/agent/dashboard",
  },
  {
    id: 2,

    name: "Bill Payments",
    icon: <PaymentIcon />,
    to: "/agent/payments",
  },
  {
    id: 3,

    name: "Bank Transfers",
    icon: <AccountBalanceIcon />,
    to: "/agent/transfers",
  },
  {
    id: 6,

    name: "Transactions",
    icon: <TableChartIcon />,
    to: "/agent/transactions",
  },
  {
    id: 7,

    name: "Referals",
    icon: <PeopleIcon />,
    to: "/agent/agents",
  },

  {
    id: 8,

    name: "Settings",
    icon: <SettingsIcon />,
    to: "/agent/settings",
  },

  {
    id: 9,

    name: "Get Help",
    icon: <HelpIcon />,
    to: "/agent/help",
  },
  {
    id: 10,

    name: "Logout",
    icon: <PowerSettingsNewIcon />,
    to: "/agent/logout",
  },
];

//    sidebarItems
